:host {
  display: block;
}

.action-link {
  display: inline-block;
  margin-top: var(--gap);
  padding: var(--padding) var(--padding-l);
  background: var(--color-bg-accent);
  color: var(--color-text-inverse);
  text-decoration: none;
  border-radius: var(--border-radius);
  font-weight: var(--font-weight-medium);
}
